<script>
  import RecRequestGroupModal from '@app-components/modal/RecRequestGroupModal.svelte';
  import UserAjax from '@ajax/user';
  import { getCurrentUserStore } from '@stores/current_user';

  export let mobile = false;

  let showRecRequestGroupModal = false;
  let currentUser = getCurrentUserStore('default');

  let closeButtonClicked = function () {
    UserAjax.update(currentUser, { rec_request_group_quick_start_show: false });
    currentUser.set({
      ...currentUser,
      rec_request_group_quick_start_show: false,
    });
  };
</script>

<style style="text/scss" lang="scss">
  .tile {
    color: black;
    position: relative;
    cursor: pointer;
    border-radius: 15px;
    flex-direction: column;
    display: flex;
    background: #f5f3fc;
    width: 100%;
    padding: 40px;
    border: 2px solid transparent;
    transition: 0.25s;
    height: 240px;
    max-width: 300px;

    &:hover {
      box-shadow: 0 12px 64px -20px rgba(0, 0, 0, 0.2);

      .tile-cta {
        color: #7054dc;
      }
    }

    .close-btn {
      position: absolute;
      top: 20px;
      right: 20px;

      path {
        stroke: #d5cfea !important;
      }

      &:hover {
        path {
          stroke: #a893f9 !important;
        }
      }
    }

    .tile-title {
      font-weight: bold;
      font-size: 24px;
      line-height: 30px;
      color: #241a4d;
    }

    .tile-description {
      font-size: 14px;
      line-height: 18px;
      color: #665e83;
      opacity: 0.8;
      margin-top: 8px;
    }

    .tile-cta {
      margin-top: auto;
      font-size: 18px;
      line-height: 32px;
      color: #a893f9;
    }
  }

  .mobile {
    height: 206px;
    padding: 30px;
  }
</style>

<div
  on:click={() => (showRecRequestGroupModal = true)}
  class="tile undraggable undroppable"
  class:mobile={mobile}
  style="background-image: url(/images/rec_request_group/tile-bg-line.png)">
  {#if showRecRequestGroupModal}
    <RecRequestGroupModal mobile={mobile} bind:show={showRecRequestGroupModal} />
  {/if}

  <div class="close-btn" on:click|preventDefault|stopPropagation={closeButtonClicked}>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
        <rect width="12" height="12" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M7.14978 6.08842C7.13814 6.07681 7.1289 6.06302 7.1226
              6.04783C7.1163 6.03265 7.11305 6.01637 7.11305 5.99993C7.11305
              5.98349 7.1163 5.96721 7.1226 5.95202C7.1289 5.93683 7.13814
              5.92304 7.14978 5.91143L11.7811 1.28062C11.9217 1.13979 12.0006
              0.948872 12.0005 0.749857C12.0004 0.550842 11.9212 0.360034
              11.7803 0.219408C11.6395 0.0787831 11.4486 -0.000140457 11.2496
              1.87653e-07C11.0506 0.000140832 10.8598 0.0793341 10.7191
              0.220158L6.08832 4.84897C6.07671 4.86061 6.06292 4.86985 6.04773
              4.87615C6.03254 4.88245 6.01626 4.8857 5.99982 4.8857C5.98338
              4.8857 5.9671 4.88245 5.95192 4.87615C5.93673 4.86985 5.92294
              4.86061 5.91133 4.84897L1.28051 0.220158C1.21088 0.150495 1.12821
              0.0952284 1.03722 0.0575143C0.946233 0.0198001 0.848706
              0.000376929 0.75021 0.000353716C0.551289 0.000306834 0.360496
              0.079283 0.219805 0.219908C0.079113 0.360534 4.69031e-05 0.551289
              2.08609e-08 0.75021C-4.68614e-05 0.949132 0.0789293 1.13992
              0.219555 1.28062L4.84987 5.91143C4.86151 5.92304 4.87074 5.93683
              4.87705 5.95202C4.88335 5.96721 4.88659 5.98349 4.88659
              5.99993C4.88659 6.01637 4.88335 6.03265 4.87705 6.04783C4.87074
              6.06302 4.86151 6.07681 4.84987 6.08842L0.219555 10.7197C0.149924
              10.7894 0.0946965 10.8721 0.0570253 10.9631C0.019354 11.0541
              -2.31929e-05 11.1516 2.08609e-08 11.2501C4.69031e-05 11.4491
              0.079113 11.6398 0.219805 11.7804C0.289468 11.8501 0.372164
              11.9053 0.463171 11.943C0.554179 11.9806 0.651715 12 0.75021
              12C0.949132 12 1.13989 11.9209 1.28051 11.7802L5.91133
              7.14888C5.92294 7.13724 5.93673 7.12801 5.95192 7.1217C5.9671
              7.1154 5.98338 7.11216 5.99982 7.11216C6.01626 7.11216 6.03254
              7.1154 6.04773 7.1217C6.06292 7.12801 6.07671 7.13724 6.08832
              7.14888L10.7191 11.7802C10.8598 11.9209 11.0505 12 11.2494
              12C11.4484 12 11.6391 11.9211 11.7798 11.7804C11.9205 11.6398
              11.9996 11.4491 11.9996 11.2501C11.9997 11.0512 11.9207 10.8604
              11.7801 10.7197L7.14978 6.08842Z"
          fill="black" />
      </g>
    </svg>
  </div>

  <div class="tile-title">Quick start</div>
  <div class="tile-description">Create a list by answering a quiz</div>
  <div class="tile-cta">View Quizzes</div>
</div>
